import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const WarehousingRevenueLeasing = () => {
    
    const sections = [
        { label: "Status", value: "Status", items: [] },
        { label: "Tenant Name", value: "tenantName", items: [] },
        { label: "Escalation", value: "Escalation", items: [] },
    ];

    return (
        <MasterData pageTitle="Warehousing" sections={sections} />
    );
};

export default WarehousingRevenueLeasing;